import { Box, Layout, FullLoadingSpinner } from '@capitalise/ui-design-system';
import { lazy, Suspense } from 'react';

import LoggedNavbar from '../../LoggedNavbar';
const TeamWizzard = lazy(() => import('../../TeamWizzard'));
const MonitorWizzard = lazy(() => import('../../MonitorWizzard'));
const ResponsesReportWizzard = lazy(() => import('../../ResponsesReportWizzard'));

// With the new 2021 design system layout
export default function withNewLayout(Component) {
  return (props) => (
    <Layout navbarOffset="70px">
      <LoggedNavbar />
      <Box
        as="main"
        minHeight="100vh"
        height="100%"
        width="100%"
        paddingTop="70px"
        display="flex"
        flexDirection="column"
      >
        <Component {...props} />
      </Box>
      <Suspense fallback={<FullLoadingSpinner />}>
        <TeamWizzard />
      </Suspense>
      <Suspense fallback={<FullLoadingSpinner />}>
        <MonitorWizzard />
      </Suspense>
      <Suspense fallback={<FullLoadingSpinner />}>
        <ResponsesReportWizzard />
      </Suspense>
    </Layout>
  );
}
